import React from 'react';
import BarChart from '../../ui/BarChart';

const IssuesRaisedSolvedChart = ({ data = [], labels = null, onExpand }) => {
  // Data should already be in { raised: number, solved: number } format from parent
  const chartData = data;

  // Always show the chart structure, even with empty data
  return (
    <BarChart
      data={chartData}
      labels={labels}
      title="Issues Raised and solved"
      xAxisLabel="Sites"
      yAxisLabel="Raised and solved"
      barColor="#22c55e"
      onExpand={onExpand}
      className="h-80"
    />
  );
};

export default IssuesRaisedSolvedChart;
